// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"c8d3685a","474":"bcc948b7"}[chunkId] + ".chunk.js";
};